export const logo = require("./logo3x.png");

export const oldArrow = require("./ic_old@3x.png");

export const moreArrow = require("./ic_more@3x.png");

export const spinner = require("./spinner.png");

export const expandIcon = require("./ic_close@3x.png");
